// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Img from "@store/MobiusOverrides/Img/Img";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

export interface CanadaCountryIconStyles {
    flag?: InjectableCss;
}

export const canadaCountryIconStyles: CanadaCountryIconStyles = {
    flag: {
        css: css`
            width: ${pxToRem(48)};
            background: ${getColor("common.background")};
        `,
    },
};

const styles = canadaCountryIconStyles;

const CanadaCountryIcon = () => {
    return (
        <Img
            {...styles.flag}
            src="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAZCAYAAAB3oa15AAACDUlEQVRYhcWYv0tcQRDHP3s5FSIRgqSxEULAJmAE/wAhBAuLXCGCniAYQwgnqS1iZWlCorX/gY3tFXpqIyIYUVAMliks/BHC+SMhdxPWW+R8vLu8t2/3/MLeg9md+c7MG2bnnfoC8oJoKMOfl9Af8bgVliGfguYoujv6pwAi0VcxjlMCj/WKqVOM6o/2PZUwYf/DJJDzSeAtAJP5LDAa9y3EgfMABOaMw2+BLrNyZm9G4KlLvrRLYwa9wDrwsEo2ITAItCmYdknmo4QOgefczXQn0A3suyZzFoDJsMb3OscOzNkRV7zWJSSV2h4ANoFj4KtAB3BUR21f4A3wSWALeAC8AlYV7Fk5kuQeEDgRKAucmf1TgXGB8xDdC4Gxqr1jgb8ClwJPqmzGugeSBpAPOfNL4HeI/NoEHJRvBGw29CL7FiJ7RPgo0AK0h8i3kzhgHYDAFDCchNzgtcCsrXKSN7BQ4w3ExS7w2VbZOgAFJwoyuvsAJUszOglZVelidnAxjQq8E/gZw47uSB9r2GpcFwoQZ6raab2lzwzVsXM/47SCJeAqIC7VKK+CK15nw5zAB+CHce7QjBR6JtKT6ZqZjZ6Z55i+jV3wOgtAwTyVdQuBHt3/FSy64gnC9xeZvtCafBI0IgAf3xy38B2AnjZbfRJ4zY6C9z7ta6Rv/luJiHKlnvt8OrQCTVHLYgf4BwUBrDZxbfm4AAAAAElFTkSuQmCC"
            alt="https://www.grimco.ca/"
        />
    );
};

export default CanadaCountryIcon;
